import { render } from "./EquipmentGrid.vue?vue&type=template&id=45187af9"
import script from "./EquipmentGrid.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./EquipmentGrid.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script